import { render, staticRenderFns } from "./camera-setting.vue?vue&type=template&id=ffd45e94&scoped=true"
import script from "./camera-setting.vue?vue&type=script&lang=js"
export * from "./camera-setting.vue?vue&type=script&lang=js"
import style0 from "./camera-setting.vue?vue&type=style&index=0&id=ffd45e94&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd45e94",
  null
  
)

export default component.exports